import { render, staticRenderFns } from "./DescriptionComp.vue?vue&type=template&id=f4a3e3d0&"
var script = {}
import style0 from "./DescriptionComp.vue?vue&type=style&index=0&id=f4a3e3d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports